import { IconGhostWaveWall } from '@veneer/core';
import tokens from '@veneer/tokens';
import styled from 'styled-components';

export const ContentSectionNoSubscriptions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${tokens.typography.size9};
`;

export const IconGhost = styled(IconGhostWaveWall)`
  && {
    color: ${tokens.color.gray9};
  }
`;

export const NoSubscriptions = styled.span`
  color: ${tokens.color.gray9};
  font-size: ${tokens.typography.size2};
  line-height: ${tokens.typography.size5};
`;

export const HPStoreSubscriptionsInfo = styled.div`
  display: flex;
  flex: 1;

  p {
    font-size: ${tokens.typography.size2};
    font-weight: 400;
    height: ${tokens.typography.size5};
  }
`;
